export function obterListaMdfeTotCUnid() {
  return (
    [
      { label: '01 - Quilograma | KG', value: 'KG' },
      { label: '02 - Tonelada | TON', value: 'TONELADA' },
    ]
  );
}
